import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';


@IonicPage()
@Component({
  selector: 'page-report-financial',
  templateUrl: 'report-financial.html',
})
export class ReportFinancialPage {

  meses = new Array();
  anos = new Array();
  form: any = {
    mes: "",
    ano: ""
  }
  resultData : any = null;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private service:  ServiceProvider, private msgHelper: MessageHelper) {
  }

  ionViewWillEnter()
  {
    this.msgHelper.createLoading('crescent','Carregando...');
    this.msgHelper.showLoading();

    this.service.postData({},"/cobrancas/periodos").then((result: any) => {
      this.msgHelper.closeLoading();
      let resultData : any = result;
      if (resultData.result == 0){
        return this.msgHelper.showAlert("Opps!",result.message);
      }

      console.log(resultData);

      this.meses = resultData.data.meses;
      this.anos = resultData.data.anos;
      
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Oops!", error.message);
    });
  }

  renderMes(mes : any){
    let text = "";
    switch (mes) {
      case "1":
        text = "Janeiro";
        break;
      case "2":
        text = "Fevereiro";
        break;
      case "3":
        text = "Março";
        break;
      case "4":
        text = "Abril";
        break;
      case "5":
        text = "Maio";
        break;
      case "6":
        text = "Junho";
        break;
      case "7":
        text = "Julho";
        break;
      case "8":
        text = "Agosto";
        break;
      case "9":
        text = "Setembro";
        break;
      case "10":
        text = "Outubro";
        break;
      case "11":
        text = "Novembro";
        break;
      case "12":
        text = "Dezembro";
        break;
      default:
        break;
    }
    return text;
  }

  /**
   * Gera o PDF de relatório
   */
  generate()
  {
    this.msgHelper.createLoading('crescent','Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.form,"/cobrancas/document").then((result: any) => {
      this.msgHelper.closeLoading();
      let resultData : any = result;
      if (resultData.result == 0){
        return this.msgHelper.showAlert("Opps!",result.message);
      }

      console.log(resultData);
      this.resultData = resultData.data;
      
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Oops!", error.message);
    });
  }

  transformValor(valor : number, withCurrency : boolean = false)
  {
    var numero = valor.toFixed(2).split('.');
    numero[0] =  numero[0].split(/(?=(?:...)*$)/).join('.');
    if (withCurrency){
      return "R$" + numero.join(',');
    }
    return numero.join(',');
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-financial/report-financial.ts